export default __webpack_public_path__ + "static/media/scanme.44574fb7.png";